/** 設備自動售后菜單（990350+；SSOT 見 099_device_auto_service_schema_and_menu.sql） */
export const DEVICE_SERVICE_MENU_IDS = {
  group: 990350,
  workbench: 990351,
  myAssignments: 990352,
  assignees: 990353,
  maintenance: 990354,
  faultPolicy: 990355,
  enterprisePolicy: 990356,
  mobile: 990357,
  bills: 990358,
  analytics: 990359,
  buttons: {
    orderView: 990360,
    orderCreate: 990361,
    orderCancel: 990362,
    orderAccept: 990363,
    orderComplete: 990364,
    orderProgress: 990365,
    assignmentView: 990366,
    assigneeManage: 990370,
    billConfirm: 990371,
    billIssue: 990372,
    billPay: 990373
  }
}

export const DEVICE_SERVICE_STATUS_LABEL = {
  OPEN: '待派工',
  ASSIGNED: '已派工',
  IN_PROGRESS: '維修中',
  REPAIR_COMPLETED: '待驗證',
  CLOSED: '已結案',
  CANCELLED: '已取消'
}

export const DEVICE_SERVICE_ORDER_TYPE_LABEL = {
  FAULT_AUTO: '故障自動',
  FAULT_MANUAL: '故障手動',
  MAINTENANCE_AUTO: '保養自動',
  MAINTENANCE_MANUAL: '保養手動',
  HOME_USER_REQUEST: '家用報修'
}

export const DEVICE_SERVICE_SEGMENT_LABEL = {
  HOME: '家用',
  BUSINESS: '商用'
}

export const DEVICE_SERVICE_SKILL_LEVEL_LABEL = {
  EXPERT: '專家',
  SENIOR: '高級',
  INTERMEDIATE: '中級',
  JUNIOR: '初級'
}

export const DEVICE_SERVICE_SKILL_LEVELS = ['EXPERT', 'SENIOR', 'INTERMEDIATE', 'JUNIOR']

export const DEVICE_SERVICE_WARRANTY_CHARGE_LABEL = {
  FREE: '免費',
  CHARGE: '收費'
}

/** 配件價目新增時記住上次選中的產品型號（localStorage） */
export const DEVICE_SERVICE_PARTS_LAST_MODEL_KEY = 'deviceService.partsCatalog.lastDeviceModelId'

/** 策略/价目页记住上次选中的配置对象（标准策略 sentinel 或商家 id） */
export const DEVICE_SERVICE_POLICY_TARGET_ENTERPRISE_KEY = 'deviceService.policy.targetEnterpriseId'

/** 配置对象：标准策略（登录节点默认继承） */
export const DEVICE_SERVICE_POLICY_TARGET_STANDARD = '__STANDARD__'

/** 配件价目筛选：仅全机型通用 */
export const DEVICE_SERVICE_PARTS_FILTER_UNIVERSAL = '__UNIVERSAL__'



// WEBPACK FOOTER //
// ./src/constants/deviceService.js